import { render, staticRenderFns } from "./TheMenuItem.vue?vue&type=template&id=0f2cc085&scoped=true&"
import script from "./TheMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuItem.vue?vue&type=style&index=0&id=0f2cc085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cc085",
  null
  
)

export default component.exports